$(document).ready(function () {
  if (window.matchMedia("(max-width: 990px)").matches) {
    $(".mak-ancmnt-scroll").slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 1000,
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow:
        "<img class='mak-prev prev slick-prev' src='https://cdn.shopify.com/s/files/1/0883/8155/5021/files/lsaxxdaq7ism8c66sqc.svg?v=1742161899'>",
      nextArrow:
        "<img class='mak-next next slick-next' src='https://cdn.shopify.com/s/files/1/0883/8155/5021/files/xwlu9vv9rqm8c66dog.svg?v=1742161899'>",
    });
  }
  $(".product-main-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    adaptiveHeight: true,
    prevArrow:
      "<img class='prev ars-prv slick-prev' src='https://cdn.shopify.com/s/files/1/0883/8155/5021/files/Vector_2.svg?v=1741545137'>",
    nextArrow:
      "<img class='next ars-nxt slick-next' src='https://cdn.shopify.com/s/files/1/0883/8155/5021/files/Vector_1.svg?v=1741545055'>",
    fade: true,
    asNavFor: ".product-nav-slider",
  });
  $(".product-nav-slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".product-main-slider",
    dots: false,
    vertical: true,
    centerMode: false,
    arrows: false,
    focusOnSelect: true,
  });
  $(".mak-reviews-scroll").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow:
      "<img class='prev slick-prev mak-previous' src='https://cdn.shopify.com/s/files/1/0883/8155/5021/files/Vector_2.svg?v=1741545137'>",
    nextArrow:
      "<img class='next slick-next mak-nextt' src='https://cdn.shopify.com/s/files/1/0883/8155/5021/files/Vector_1.svg?v=1741545055'>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const options = { root: null, rootMargin: "0px", threshold: 0.5 };
  const imageWrappers = document.querySelectorAll(
    ".desktop-only .mak-left-side .mak-image-wrapper"
  );
  const contentWrappers = document.querySelectorAll(
    ".desktop-only .mak-right-side .mak-content-wrapper"
  );

  function callback(entries) {
    entries.forEach((entry) => {
      const index = parseInt(entry.target.dataset.index);
      if (entry.isIntersecting) {
        entry.target.classList.add("in-view");
        imageWrappers.forEach((img, i) =>
          img.classList.toggle("show", i === index)
        );
      } else {
        entry.target.classList.remove("in-view");
      }
    });
  }

  const observer = new IntersectionObserver(callback, options);
  contentWrappers.forEach((wrapper) => observer.observe(wrapper));
});
